import React from 'react'
import {
    Grid,
    Typography,
    Link as LinkHref
} from '@material-ui/core'
import {
    AppVersion
} from '../layout/listItemsMenu'

export function Footer() {
    return (
        <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
        >
            <Grid
                item
                container
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid>
                    <Typography variant="body2" component="div" color="textSecondary" align="center">
                        {'© '}
                        <LinkHref color="inherit" href="https://burgerhouse-1e72b.web.app">
                            Burger House
                        </LinkHref>{' '}
                        {new Date().getFullYear()}
                    </Typography>
                </Grid>
                <Grid style={{ padding: '0 7px 0 7px' }}> {'|'} </Grid>
                <Grid>
                    <AppVersion />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body2" component="div" color="textSecondary" align="center">
                    {'Desarrollado por '}
                    <LinkHref color="inherit" href="https://brianbentancourt.com" target="_blank">
                        Brian Bentancourt
                    </LinkHref>
                </Typography>
            </Grid>

        </Grid>

    )
}

export default Footer